/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-02-28 14:26:06
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-02-28 16:13:06
 * @FilePath: \renying\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
  import L from 'leaflet'
    import 'leaflet/dist/leaflet.css'
createApp(App).use(store).use(router).use(ElementPlus).mount('#app')
